import ArtistSoldLotPerformanceAgainstEstimate from "./ArtistSoldLotPerformanceAgainstEstimate";

export default ArtistSoldLotPerformanceAgainstEstimate;
